function ProductFilter({ categories, selectedCategory, setCategory }) {
    return (
        <div className="d-flex justify-content-center gap-2 mb-4 flex-wrap">
        <button
          className={`btn btn-md btn-outline-custom ${
            selectedCategory === "All" ? "active" : ""
          }`}
          onClick={() => setCategory("All")}
        >
          All
        </button>
        {categories.map((cat) => (
          <button
            key={cat}
            className={`btn btn-md btn-outline-custom ${
              selectedCategory === cat ? "active" : ""
            }`}
            onClick={() => setCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
      
    );
  }
  
  export default ProductFilter;
  